// extracted by mini-css-extract-plugin
export default {"blogCardsWrapper":"style-module--blogCardsWrapper--aea15","sideHolder":"style-module--sideHolder--55a9a"};